import { Component, Input, SimpleChanges } from '@angular/core';
import { CLIENT_TYPE_MAP } from 'src/app/product-capture/model/consts/client-type.const';
import { DISTRIBUTION_STRATEGY_MAP } from 'src/app/product-capture/model/consts/distribution-strategy.const';
import { TEST_PARAMETER_MAP } from 'src/app/product-capture/model/consts/test-results.const';
import { DataTableColumns } from 'src/app/product-capture/model/interfaces/data-table-columns.interface';
import {
  TestExecutionDetail,
  TestExecutionResult,
} from '../governance-checks.consts';

@Component({
  selector: 'app-governance-test-results',
  templateUrl: './governance-test-results.component.html',
  styleUrls: ['./governance-test-results.component.scss'],
})
export class GovernanceTestResultsComponent {
  @Input()
  test: TestExecutionResult;

  columns: DataTableColumns[] = [
    {
      name: 'Client Type',
      prop: 'clientType',
      resizeable: false,
      draggable: false,
      flexGrow: 1,
    },
    {
      name: 'Dist. Strategy',
      prop: 'distStrategy',
      maxWidth: 120,
      resizeable: false,
      draggable: false,
      flexGrow: 0.5,
    },
    {
      name: 'Test name',
      prop: 'testName',
      resizeable: false,
      draggable: false,
      flexGrow: 1.2,
    },
    {
      name: 'Metric',
      prop: 'metric',
      headerClass: 'text-center',
      cellClass: 'text-center',
      resizeable: false,
      draggable: false,
      flexGrow: 0.5,
    },
    {
      name: 'Test',
      prop: 'testParameter',
      resizeable: false,
      headerClass: 'text-center',
      cellClass: 'text-center',
      draggable: false,
      flexGrow: 0.5,
    },
    {
      name: 'Threshold',
      prop: 'threshold',
      headerClass: 'text-center',
      cellClass: 'text-center',
      resizeable: false,
      draggable: false,
      flexGrow: 0.5,
    },
    {
      name: 'Result',
      prop: 'result',
      headerClass: 'text-center',
      resizeable: false,
      cellClass: 'text-center paddingInternal',
      draggable: false,
      flexGrow: 0.5,
      cellTemplate: 'upperCaseStringTemplate',
    },
  ];

  messages: any = {
    emptyMessage: '',
  };

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if ('test' in changes) {
      this.test.testResult.forEach((result: TestExecutionDetail[]) => {
        result.forEach((item: TestExecutionDetail) => {
          item.distStrategy =
            DISTRIBUTION_STRATEGY_MAP[item.distStrategy] ?? item.distStrategy;
          item.clientType = CLIENT_TYPE_MAP[item.clientType] ?? item.clientType;
          item.testParameter =
            TEST_PARAMETER_MAP[item.testParameter] ?? item.testParameter;
          item.metric = item.metric ?? 0;
          item.threshold = item.threshold ?? 0;
        });
      });
    }
  }
}
